var _circle, _path, _rect, _circle2, _g, _rect2, _rect3, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle4, _circle5, _path2, _path3, _rect9, _rect10, _path4, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _circle6, _rect23, _rect24, _rect25, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTipsBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 399,
    viewBox: "0 0 426 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 267.714,
    cy: 243,
    r: 1.14286,
    fill: "#FFB2B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H399C413.912 0 426 12.0883 426 27V372C426 386.912 413.912 399 399 399H47C32.6406 399 21 387.359 21 373V0Z",
    fill: "#FFF5F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.679108,
    y: 279.217,
    width: 92,
    height: 87,
    rx: 11,
    transform: "rotate(-44.9964 0.679108 279.217)",
    fill: "#FFEBEB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 79,
    r: 35,
    fill: "#FFEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3024)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 94,
    width: 333,
    height: 202,
    rx: 9,
    fill: "#EBF9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 186.25H266C269.728 186.25 272.75 189.272 272.75 193V295.75H57.25V193C57.25 189.272 60.2721 186.25 64 186.25Z",
    fill: "#F5FEFF",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.25,
    y: 196.25,
    width: 215.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 206,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 203,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 201,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 201,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 201,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 201,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 203,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 206,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 209,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.25,
    y: 217.25,
    width: 215.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 227,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 224,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 222,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 222,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 222,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 222,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 224,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 227,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 230,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.25,
    y: 268.25,
    width: 215.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 278,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 275,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 273,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 273,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 273,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 273,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 275,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 278,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 281,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.25,
    y: 289.25,
    width: 215.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 299,
    r: 7,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 294,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 294,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 294,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 294,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 296,
    r: 1,
    fill: "#DEDEDE"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 94.25,
    width: 332.5,
    height: 201.5,
    rx: 8.75,
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.25,
    y: 235.25,
    width: 246.357,
    height: 23.5,
    rx: 2.75,
    fill: "white",
    stroke: "#73CCFE",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 246.429,
    r: 8,
    fill: "#FFDA7C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5714,
    y: 243,
    width: 6.85714,
    height: 6.85714,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4286,
    y: 240.714,
    width: 62.8571,
    height: 4.57143,
    rx: 1,
    fill: "#FFB3B3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 240.714,
    width: 9.14286,
    height: 4.57143,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 151.143,
    y: 240.714,
    width: 34.2857,
    height: 4.57143,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 193.429,
    y: 240.714,
    width: 49.1429,
    height: 4.57143,
    rx: 1,
    fill: "#C4C4C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.714,
    cy: 246.429,
    r: 1.14286,
    fill: "#FFB2B2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.714,
    cy: 249.857,
    r: 1.14286,
    fill: "#FFB2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.949 244.684C252.865 244.433 252.685 244.224 252.447 244.106C252.21 243.987 251.936 243.967 251.684 244.051C251.432 244.135 251.224 244.315 251.105 244.553C250.987 244.79 250.967 245.065 251.051 245.316L252.051 248.316C252.135 248.568 252.315 248.776 252.552 248.895C252.79 249.013 253.064 249.033 253.316 248.949C253.568 248.865 253.776 248.685 253.894 248.448C254.013 248.211 254.033 247.936 253.949 247.684L252.949 244.684ZM259.707 247.707C259.889 247.519 259.99 247.266 259.988 247.004C259.985 246.742 259.88 246.491 259.695 246.305C259.509 246.12 259.258 246.015 258.996 246.013C258.734 246.01 258.481 246.111 258.293 246.293L256.293 248.293C256.111 248.482 256.01 248.734 256.012 248.997C256.014 249.259 256.12 249.51 256.305 249.695C256.49 249.88 256.741 249.986 257.003 249.988C257.266 249.99 257.518 249.889 257.707 249.707L259.707 247.707ZM247.317 249.051C247.065 248.967 246.79 248.987 246.553 249.105C246.316 249.224 246.135 249.432 246.051 249.684C245.967 249.935 245.987 250.21 246.106 250.447C246.224 250.685 246.432 250.865 246.684 250.949L249.684 251.949C249.936 252.033 250.21 252.013 250.447 251.895C250.685 251.776 250.865 251.568 250.949 251.316C251.033 251.065 251.013 250.79 250.894 250.553C250.776 250.315 250.568 250.135 250.316 250.051L247.317 249.051ZM254.342 251.061C254.163 250.996 253.97 250.984 253.784 251.025C253.598 251.066 253.428 251.159 253.294 251.293C253.159 251.428 253.066 251.598 253.024 251.783C252.983 251.969 252.995 252.162 253.06 252.341L257.06 263.341C257.129 263.532 257.255 263.696 257.419 263.814C257.584 263.931 257.781 263.996 257.984 263.999C258.186 264.002 258.385 263.944 258.553 263.832C258.722 263.72 258.853 263.559 258.928 263.371L260.365 259.78L264.293 263.707C264.385 263.803 264.495 263.879 264.617 263.931C264.739 263.984 264.871 264.011 265.003 264.012C265.136 264.014 265.268 263.988 265.391 263.938C265.514 263.888 265.625 263.814 265.719 263.72C265.813 263.626 265.887 263.514 265.938 263.391C265.988 263.268 266.013 263.137 266.012 263.004C266.011 262.871 265.983 262.74 265.931 262.618C265.879 262.496 265.802 262.385 265.707 262.293L261.779 258.365L265.371 256.929C265.559 256.854 265.72 256.723 265.833 256.555C265.945 256.386 266.003 256.187 266 255.984C265.997 255.782 265.932 255.585 265.814 255.42C265.697 255.255 265.532 255.129 265.341 255.06L254.341 251.06L254.342 251.061ZM251.707 255.707C251.802 255.615 251.879 255.505 251.931 255.383C251.983 255.261 252.011 255.129 252.012 254.997C252.013 254.864 251.988 254.732 251.938 254.609C251.887 254.486 251.813 254.375 251.719 254.281C251.625 254.187 251.514 254.113 251.391 254.062C251.268 254.012 251.136 253.987 251.003 253.988C250.871 253.989 250.739 254.017 250.617 254.069C250.495 254.122 250.385 254.198 250.293 254.293L248.293 256.293C248.197 256.385 248.121 256.496 248.069 256.618C248.016 256.74 247.989 256.871 247.988 257.004C247.986 257.137 248.012 257.268 248.062 257.391C248.112 257.514 248.187 257.626 248.28 257.72C248.374 257.814 248.486 257.888 248.609 257.938C248.732 257.988 248.864 258.014 248.996 258.012C249.129 258.011 249.26 257.984 249.382 257.931C249.504 257.879 249.615 257.803 249.707 257.707L251.707 255.707Z",
    fill: "#FC563A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94.25H370C374.832 94.25 378.75 98.1675 378.75 103V113.75H46.25V103C46.25 98.1675 50.1675 94.25 55 94.25Z",
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 57.25,
    y: 122.25,
    width: 75.5,
    height: 43.5,
    rx: 4.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 141.25,
    y: 122.25,
    width: 128.5,
    height: 43.5,
    rx: 4.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285 122.25H378.75V286C378.75 291.385 374.385 295.75 369 295.75H287C282.72 295.75 279.25 292.28 279.25 288V128C279.25 124.824 281.824 122.25 285 122.25Z",
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 153,
    width: 62.8571,
    height: 4.57143,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 174,
    width: 39,
    height: 10,
    rx: 1,
    fill: "#ECECEC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 187,
    width: 39,
    height: 10,
    rx: 1,
    fill: "#ECECEC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 187,
    width: 39,
    height: 10,
    rx: 1,
    fill: "#ECECEC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 200,
    width: 39,
    height: 10,
    rx: 1,
    fill: "#ECECEC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 228,
    width: 88,
    height: 10,
    rx: 1,
    fill: "#ECECEC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 240,
    width: 88,
    height: 10,
    rx: 1,
    fill: "#ECECEC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 91,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 252,
    width: 88,
    height: 10,
    rx: 1,
    fill: "#ECECEC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 264,
    width: 88,
    height: 10,
    rx: 1,
    fill: "#ECECEC"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 174,
    width: 39,
    height: 10,
    rx: 1,
    fill: "#ECECEC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.5,
    cy: 138.5,
    r: 9.5,
    fill: "#FFDA7C"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 91,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3024"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 94,
    width: 333,
    height: 202,
    rx: 9,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsBg);
export default __webpack_public_path__ + "static/media/tips_bg.eafb37c870ef5b6df79a410557ed88b0.svg";
export { ForwardRef as ReactComponent };